import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadViewDataQueryVariables = {};


export type ReadViewDataQuery = (
  { __typename?: 'Query' }
  & { provingGrounds: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'abbr' | 'title'>
  )>, resourceCategories: Array<(
    { __typename?: 'ResourceCategory' }
    & Pick<Types.ResourceCategory, '_id' | 'types'>
  )> }
);

export const ReadViewDataDocument = gql`
    query ReadViewData {
  provingGrounds {
    _id
    abbr
    title
  }
  resourceCategories {
    _id
    types
  }
}
    `;

    export function useReadViewDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadViewDataQuery, ReadViewDataQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadViewDataQuery, ReadViewDataQueryVariables>(ReadViewDataDocument, baseOptions);
    };
      export function useReadViewDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadViewDataQuery, ReadViewDataQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadViewDataQuery, ReadViewDataQueryVariables>(ReadViewDataDocument, baseOptions);
      };
      
export type ReadViewDataQueryHookResult = ReturnType<typeof useReadViewDataQuery>;
export type ReadViewDataQueryResult = ApolloReactCommon.QueryResult<ReadViewDataQuery, ReadViewDataQueryVariables>;